(function () {
  const ROOT =
    window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

  const FEES = {
    embroidery: {
      handle: 'embroidery-setup-fee',
      tag: 'SetupFee_Embroidery_30'
    },

    screenprint: {
      handle: 'screen-printing-setup-fee',
      tag: 'SetupFee_Screenprint_30'
    }
  };

  const feeHandles = new Set(
    Object.values(FEES).map(fee => fee.handle)
  );

  const originalFetch = window.fetch.bind(window);

  const productCache = new Map();

  let syncing = false;
  let runAgain = false;

  async function fetchJSON(url, options) {
    const response = await originalFetch(url, options);

    if (!response.ok) {
      throw new Error(
        `Setup fee request failed: ${response.status}`
      );
    }

    return response.json();
  }

  async function getProduct(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const product = await fetchJSON(
      ROOT + 'products/' + encodeURIComponent(handle) + '.js'
    );

    productCache.set(handle, product);

    return product;
  }

  async function getFeeVariant(fee) {
    const product = await getProduct(fee.handle);

    const variant =
      product.variants.find(variant => variant.available) ||
      product.variants[0];

    if (!variant) {
      throw new Error(
        `No variant found for ${fee.handle}`
      );
    }

    return variant;
  }

  async function syncSetupFees() {
    if (syncing) {
      runAgain = true;
      return;
    }

    syncing = true;

    try {
      const cart = await fetchJSON(ROOT + 'cart.js');

      const requirements = {
        embroidery: false,
        screenprint: false
      };

      const regularHandles = [
        ...new Set(
          cart.items
            .map(item => item.handle)
            .filter(
              handle =>
                handle &&
                !feeHandles.has(handle)
            )
        )
      ];

      const products = await Promise.all(
        regularHandles.map(handle =>
          getProduct(handle)
        )
      );

      products.forEach(product => {
        const tags = Array.isArray(product.tags)
          ? product.tags
          : [];

        if (
          tags.includes(
            FEES.embroidery.tag
          )
        ) {
          requirements.embroidery = true;
        }

        if (
          tags.includes(
            FEES.screenprint.tag
          )
        ) {
          requirements.screenprint = true;
        }
      });

      const embroideryVariant =
        await getFeeVariant(FEES.embroidery);

      const screenprintVariant =
        await getFeeVariant(FEES.screenprint);

      const currentQuantities = {};

      cart.items.forEach(item => {
        currentQuantities[item.variant_id] =
          (currentQuantities[item.variant_id] || 0) +
          item.quantity;
      });

      const updates = {};

      const desiredEmbroidery =
        requirements.embroidery ? 1 : 0;

      const desiredScreenprint =
        requirements.screenprint ? 1 : 0;

      if (
        (currentQuantities[
          embroideryVariant.id
        ] || 0) !== desiredEmbroidery
      ) {
        updates[
          embroideryVariant.id
        ] = desiredEmbroidery;
      }

      if (
        (currentQuantities[
          screenprintVariant.id
        ] || 0) !== desiredScreenprint
      ) {
        updates[
          screenprintVariant.id
        ] = desiredScreenprint;
      }

      if (Object.keys(updates).length) {
        await fetchJSON(
          ROOT + 'cart/update.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body: JSON.stringify({
              updates: updates
            })
          }
        );

        document.dispatchEvent(
          new CustomEvent(
            'setup-fees:updated'
          )
        );

        if (
          window.location.pathname.endsWith(
            '/cart'
          )
        ) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(
        'Aquabella setup fee error:',
        error
      );
    } finally {
      syncing = false;

      if (runAgain) {
        runAgain = false;

        setTimeout(
          syncSetupFees,
          100
        );
      }
    }
  }

  /*
   * Watch Shopify cart requests.
   * Refresh uses Shopify's Ajax cart system.
   */

  window.fetch = async function (...args) {
    const response =
      await originalFetch(...args);

    try {
      const input = args[0];

      const url =
        typeof input === 'string'
          ? input
          : input && input.url
          ? input.url
          : '';

      const options = args[1] || {};

      const method =
        (
          options.method ||
          (input &&
          typeof Request !== 'undefined' &&
          input instanceof Request
            ? input.method
            : 'GET')
        ).toUpperCase();

      const cartMutation =
        /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;

      if (
        method === 'POST' &&
        cartMutation.test(url)
      ) {
        setTimeout(
          syncSetupFees,
          100
        );
      }
    } catch (error) {
      console.error(
        'Setup fee cart listener:',
        error
      );
    }

    return response;
  };

  /*
   * Before checkout, force one final fee check.
   */

  document.addEventListener(
    'click',

    async function (event) {
      const checkout =
        event.target.closest(
          'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
        );

      if (!checkout) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      await syncSetupFees();

      window.location.href =
        ROOT + 'checkout';
    },

    true
  );

  /*
   * Check the cart on every page load.
   */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      syncSetupFees
    );
  } else {
    syncSetupFees();
  }
})();